import React, { useEffect } from "react";
import { Form, message, Modal } from "antd";
import moment from "moment";

import { useFetchConstant } from "apis/constant";

import FormDatePicker from "components/FormDatePicker/FormDatePicker";
import Locale from "react-intl-universal";

const { useForm } = Form;

const ClientJoinDateModal = ({ visible, onOk, onCancel }) => {
  const [form] = useForm();

  const { data: adviseeCategoriesConst } = useFetchConstant(
    "adviseeCategories"
  );

  useEffect(() => {
    form.setFieldsValue({ joinDate: moment() });
  });

  const handleOnOkButtonClick = async (e) => {
    e.preventDefault();
    try {
      const { joinDate } = await form.validateFields();

      const formattedValues = {
        joinDate: joinDate.format("YYYY-MM-DD"),
        category: adviseeCategoriesConst.CLIENT.code,
      };

      onOk(formattedValues);
    } catch (error) {
      error.errorFields.forEach((field) => message.error(field.errors[0]));
    }
  };

  return (
    <Modal
      title={Locale.get("Advisees.clientJoinDate.modalTitle")}
      visible={visible}
      okText={Locale.get("Advisees.clientJoinDate.modalOkText")}
      onOk={handleOnOkButtonClick}
      onCancel={onCancel}
    >
      <Form form={form}>
        <FormDatePicker
          label={Locale.get("Advisees.clientJoinDate.modalLabel")}
          name="joinDate"
        />
      </Form>
    </Modal>
  );
};

export default ClientJoinDateModal;
